/* ================================
   BASE CONFIG
================================ */
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

/* ================================
   AUTH
================================ */
export const AUTH_API = {
  LOGIN: `${API_BASE_URL}/api/users/handlegoauth`, //used

  LOGOUT: `${API_BASE_URL}/auth/logout`,
  REGISTER: `${API_BASE_URL}/auth/register`,
  PROFILE: `${API_BASE_URL}/auth/me`,
};

/* ================================
   USERS (Admin)
================================ */
/* NOTE: GET_ALL / GET_BY_ID / UPDATE / DELETE were removed. They pointed at
   `${API_BASE_URL}/users/...` — missing the /api prefix, the same defect that
   broke token refresh and API-usage monitoring — and even with the prefix this
   backend has no such REST routes (user reads go through
   POST /api/admin/fetchusers and POST /api/admin/user-stats). Nothing imported
   them. Guarded by regression/frontend-api-paths. */
export const USER_API = {
  SUSPEND_USER: (userId) => `/api/admin/users/${userId}/suspend`, //used
  UNSUSPEND_USER: (userId) => `/api/admin/users/${userId}/unsuspend`, //used
  // Abuse Report → Force Disconnect. POST { accountId }. Admin only.
  FORCE_DISCONNECT_TAPO: (userId) => `/api/admin/users/${userId}/tapo/force-disconnect`,
  EXTEND_TRIAL: `/api/subscription/extend-trial`,
  PROMOTE_USER: `/api/admin/app-users`,
  INVITE_USER: `/api/admin/app-users`,
  FETCH_INVITES: `/api/admin/app-users-list`,
  CANCEL_INVITE : '/api/admin/app-users',
};

/* ================================
   ADMIN · PER-USER VISIBILITY (read-only)
   Relative paths — these go through axiosInstance, which already carries
   baseURL. Never prefix them with API_BASE_URL again.
================================ */
export const ADMIN_USER_DATA_API = {
  SCHEDULES: (userId) => `/api/admin/users/${userId}/schedules`,
  SCHEDULE_BY_ID: (userId, scheduleId) =>
    `/api/admin/users/${userId}/schedules/${scheduleId}`,
  DEVICES: (userId) => `/api/admin/users/${userId}/devices`,
  ROOMS: (userId) => `/api/admin/users/${userId}/rooms`,
  ROOM_BY_ID: (userId, roomId) => `/api/admin/users/${userId}/rooms/${roomId}`,
  NEXT_RUNS: (userId) => `/api/admin/users/${userId}/next-runs`,
  // Current subscription, auto-renew, and history. ?refresh=true re-reads
  // RevenueCat first; without it the stored store-snapshot is served.
  SUBSCRIPTION: (userId) => `/api/admin/users/${userId}/subscription`,
  USER_STATS: `/api/admin/user-stats`, // POST { userId }
};

/* NOTE: the old SCHEDULE_API block was removed. Its five paths (/schedules/...)
   do not exist on this backend — schedules are served from /api/schedule — and
   nothing imported it. Admin schedule reads go through ADMIN_USER_DATA_API. */

/* ================================
   SCHEDULE HISTORY
================================ */
export const SCHEDULE_HISTORY_API = {
  LIST: `${API_BASE_URL}/schedule-history/list`,
  SEARCH: `${API_BASE_URL}/api/historylogs/search`, //used
};

/* ================================
   ANALYTICS (Admin Web Only)
================================ */
export const ANALYTICS_API = {
  // ⚠️ Was missing the /api prefix; the route is mounted at /api/admin/api-usage.
  USAGE_MONITORING: `${API_BASE_URL}/api/admin/api-usage`,//used
  AGENT_ACTIVITY: `${API_BASE_URL}/analytics/agent-activity`,
  LOGS_ANALYTICS: `${API_BASE_URL}/analytics/logs`,
};

export const ADMIN_STATS_API = {
  USER_PROVIDER_STATS: `${API_BASE_URL}/api/admin/fetchuserstat`, //used
  DEVICE_STATS: `${API_BASE_URL}/api/admin/fetchdevicestat`, //used
  SUBSCRIPTION_STATS: `${API_BASE_URL}/api/admin/subscription-stats`, //used
  SUBSCRIPTION_TREND: `${API_BASE_URL}/api/admin/subscription-trend`, // GET ?from=YYYY-MM-DD&to=YYYY-MM-DD
};

/* ================================
   SETTINGS (Admin)
================================ */
export const SETTINGS_API = {
  GET: `${API_BASE_URL}/api/admin/configuration/settings`, //used
  UPDATE: `${API_BASE_URL}/api/admin/configuration/settings`, //used
};

/* ================================
   INTEGRATIONS
================================ */
export const INTEGRATIONS_API = {
  GET: `${API_BASE_URL}/api/integrations`, //used
};
